export const mapPermissionsToFriendlyName = function (permission: string) {
  switch (permission) {
    case 'update-task':
      return 'Create/Edit Tasks';
    case 'put-users':
      return 'Create/Edit Users';
    case 'set-task-template':
      return 'Create/Edit Task Templates';
    case 'upsert-task-group':
      return 'Create/Edit Task Groups';
    case 'rm-ui-access':
      return 'Resource Manager Access';
    case 'upsert-resource':
      return 'Add Resource';
    case 'upsert-resource-schedules':
      return 'Create/Edit Resource Schedule';
    case 'upsert-resource-events':
      return 'Create/Edit Resource Event';
    case 'put-roles':
      return 'Create/Edit Roles';
    case 'set-regions':
      return 'Create/Edit Regions';
    case 'reset-users':
      return 'Reset SSO User';
    case 'access-complex-loss':
      return 'Complex Loss Access';
    case 'upsert-complex-loss':
      return 'Create/Edit Complex Loss';
    case 'edit-company-page':
      return 'Create/Edit Company Data';
    case 'access-capacity-dashboard':
      return 'Capacity Dashboard Access';
    case 'cancel-claim-owner':
      return 'Cancel Claim Owner';
    case 'run-optimizer':
      return 'Run Optimizer';
    case 'create-task':
      return 'Create Task';
    case 'upsert-cws':
      return 'Create/Edit CWS';
    case 'create-reports':
      return 'Create Reports';
    case 'access-attribute-group-definition':
      return 'View Group Attribute Definition';
    case 'read-notes':
      return 'View Notes';
    case 'manage-notes':
      return 'Create/Edit Notes';
    case 'view-resource-audit':
      return 'View Resource History';
    default:
      return permission;
  }
};
